<template>
  <div
    class="category-item d-flex justify-content-center align-items-center mb-2 px-4 cursor-pointer animate__animated animate__fadeIn"
    draggable
    @dragstart="$emit('dragstart', $event)"
    @drop="$emit('drop', $event)"
    @dragover="$emit('dragover')"
    @dragleave="$emit('dragleave')"
  >
    <p class="category-item-label my-0">{{ category.name }}</p>

    <button
      type="button"
      class="button-remove text-white bg-danger rounded-circle border-0 d-flex justify-content-center align-items-center"
      @click="removeItem"
    >
      <i class="ri-delete-bin-line"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: "CategoryItem",
  props: {
    category: Object,
  },
  methods: {
    removeItem() {
      this.$emit('remove', this.category.id)
    }
  }
};
</script>

<style lang="stylus">
@import "../Styles/category-item.styl"
</style>
